// if value of a route mapping is string, by being included in the breadcrumb

import i18n from "@/locales/i18n";

// it becomes rewritten and (click)disabled if null
export const defaultRouteMappings: Record<string, string | null> = {
	"/administracija/clanovi-komisije": "Članovi komisije",
	"/bpm": null,
	"/izvjestaji": null,
	"/administracija/sifrarnik": "Šifrarnik",
	"/ulazne-posiljke": null,
	"/pismena": null,
	"/poslovni-partneri": null,
	"/administracija": null,
	"/zup-it": null,
	"/postavke-aplikacije": null,
	"/postavke-aplikacije/konfiguracija-rokova": null,
	"/postavke-aplikacije/konfiguracija-obavijesti": null,
	"/postavke-aplikacije/fina-e-racun": "FINA e-Račun",
	"/poruke": null,
	"/dokumenti": null,
	"/racuni": "Računi",
	"/dms": null
};

// key => path, value => property key in DataTables 'currentRow' object in 'useDataToBreadcrumbs'
export const defaultRoutePropertyMappings: Record<string, string | null> = {
	"poruke/mailovi": "subject",
	"pismena/akti": "title",
	"pismena/podnesci": "title",
	"pismena/interni-akti": "title",
	"kategorizacija/zahtjevi": "requestNumber",
	racuni: "invoiceNumber"
};
